import { NgModule } from '@angular/core';
import { DashExpenseGraphComponent } from './dash-expense-graph.component';
import { SharedModule } from 'app/components/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IfOnDomModule } from 'app/directives/if-on-dom.module';
import { ReportsService } from 'app/services/reports/reports.service';
import { TabularReportModule } from 'app/components/app-layout/shared/tabular-report/tabular-report.module';
import { SingleDateRangeSimpleModule } from 'app/components/app-layout/shared/report-filters/single-date-range-simple/single-date-range-simple.module';
import { LegfiCurrencyPipe } from 'app/pipes/format/legfi-currency.pipe';
import { LegfiCurrencyPipeModule } from 'app/pipes/format/legfi-currency.module';

@NgModule({
    imports: [
        SharedModule,
        NgbModule,
        IfOnDomModule,
        SharedModule,
        TabularReportModule,
        SingleDateRangeSimpleModule,
        LegfiCurrencyPipeModule,
    ],
    exports: [
        DashExpenseGraphComponent,
    ],
    declarations: [DashExpenseGraphComponent],
    providers: [
        ReportsService,
        LegfiCurrencyPipe,
    ],
})
export class DashExpenseGraphModule
{
}
